import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Modal, Button, Message, Checkbox, Header } from 'semantic-ui-react';
import { postWithAuth } from 'src/api';
import { TERMS_VERSION } from 'src/app.constants';
import messages from 'src/messages';
import { RootStateOrAny, store } from 'src/store';
import { updateTermsNConditions } from '../pages/mainframe/mainframe.reducer';
import MainFrame from '../pages/mainframe/MainFrame';
import { useNavigate, useLocation } from 'react-router-dom';

const html = `<!DOCTYPE html>
<html>
  <head>
    <!-- <meta charset="UTF-8"> -->
    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="HandheldFriendly" content="True" />
    <meta name="MobileOptimized" content="320" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />
    <link
      rel="shortcut icon"
      type="image/x-icon"
      href="/favicon.ico"
    />
    <title>Terms and Conditions</title>
    <style>
      *::after,
      *::before {
        box-sizing: border-box;
      }
      html {
        -webkit-font-smoothing: antialiased;
        direction: ltr;
      }
      html,
      body {
        margin: 0;
        padding: 0;
      }
      body {
        font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial,
          sans-serif;
        font-size: 14px;
        color: #1b1e21;
      }
      .wrapper {
        width: 90%;
        margin: 0 auto;
        font-weight: 400;
        line-height: 1.5625;
        text-align: justify;
      }
      .incline {
        font-style: italic;
      }
      h1.heading {
        padding: 1em 0;
        background: #0f3548;
        font-size: 30px;
        font-weight: 400;
        color: #fff;
        text-align: center;
      }
      p,
      ol,
      li {
        line-height: 24px;
        margin-bottom: 1em;
      }
      ol > li > b,
      ol > li > u {
        margin-left: 5px;
      }
      ol {
        counter-reset: item;
      }
      li {
        display: block;
      }
      li:before {
        content: counters(item, ".") " ";
        counter-increment: item;
      }
      .cap {
        text-transform: capitalize;
      }
      .m-n {
        margin: 0;
      }
      .m-r-xs {
        margin-right: 5px;
      }
      div > ol > li:before {
        font-weight: bold;
        font-size: 15px;
      }
      @media all and (max-width: 768px) {
        h1.heading {
          font-size: 1.5em;
        }
        ol {
          padding-inline-start: 0;
        }
      }
    </style>
  </head>
  <body>
    <h1 class="heading m-n">Airspan Networks, SAAS Terms Of Service</h1>
    <div class="wrapper">
      <p>
        THESE TERMS OF SERVICE (THE &quot;<b>TERMS</b>&quot;) ARE A LEGAL
        AGREEMENT BETWEEN YOU (&quot;<b>CUSTOMER</b>&quot;) AND AIRSPAN
        NETWORKS HOLDINGS LLC (&quot;<b>AIRSPAN NETWORKS</b>&quot;). BY CLICKING THE
        &quot;<b>I ACCEPT</b>&quot; BUTTON, EXECUTING AN ORDER FORM THAT
        INCLUDES THESE TERMS BY REFERENCE OR USING THE AIRSPAN NETWORKS
        SERVICES, CUSTOMER ACKNOWLEDGES THAT CUSTOMER HAS REVIEWED AND ACCEPTS
        THESE TERMS. IF YOU ARE AGREEING TO THESE TERMS AS AN INDIVIDUAL
        &quot;<b>CUSTOMER</b>&quot; REFERS TO YOU INDIVIDUALLY. IF YOU ARE
        AGREEING TO THESE TERMS AS A REPRESENTATIVE OF AN ENTITY, YOU REPRESENT
        THAT YOU HAVE THE AUTHORITY TO BIND THAT ENTITY AND
        &quot;<b>CUSTOMER</b>&quot; REFERS TO THAT ENTITY AND ALL THE USERS
        SPECIFIED IN THE ORDER FORM. IF CUSTOMER DOES NOT AGREE WITH ALL OF
        THESE TERMS, DO NOT ACCESS OR OTHERWISE USE THE AIRSPAN NETWORKS
        SERVICE. AIRSPAN NETWORKS MAY MAKE CHANGES TO THE AIRSPAN NETWORKS
        SERVICES AT ANY TIME. IN ADDITION, AIRSPAN NETWORKS MAY MAKE CHANGES TO
        THESE TERMS AT ANY TIME, AND AIRSPAN NETWORKS WILL POST NOTICE OF THE
        CHANGES ON THE LOG-IN SCREEN FOR THE AIRSPAN NETWORKS SERVICE AND
        REQUIRE YOU TO ACKNOWLEDGE AND AGREE TO THE CHANGED TERMS. CUSTOMER’S
        CONTINUED USE OF THE AIRSPAN NETWORKS SERVICES AFTER SUCH CHANGES HAVE
        BEEN POSTED WILL SIGNIFY CUSTOMER’S ASSENT TO AND ACCEPTANCE OF THE
        REVISED TERMS.
      </p>
      <div>
        <ol>
          <li>
            <b>DEFINITIONS.</b>
            <ol>
              <li>
                <b class="incline">&quot;LINKPlanner&quot;</b> means the Service
                provided by Airspan Networks pursuant to these Terms through or
                in connection with its LINKPlanner network planning system.
              </li>
              <li>
                <b class="incline">&quot;Customer Data&quot;</b> means all data
                submitted, stored, posted, displayed, or otherwise transmitted
                by or on behalf of Customer or any User and received, processed
                or analyzed by or through LINKPlanner.
              </li>
              <li>
                <b class="incline">&quot;Customer System&quot;</b> means
                Customer’s internal website(s), servers and other equipment and
                software used in the conduct of Customer’s business.
              </li>
              <li>
                <b class="incline">&quot;Documentation&quot;</b> means the
                online user instructions and help files made available by
                Airspan Networks for use with LINKPlanner, as may be updated
                from time to time by Airspan Networks.
              </li>
              <li>
                <b class="incline">&quot;Intellectual Property Rights&quot;</b>
                means all intellectual property rights or similar proprietary
                rights, including (a) patent rights and utility models, (b)
                copyrights and database rights, (c) trademarks, trade names,
                domain names and trade dress and the goodwill associated
                therewith, (d) trade secrets, (e) mask works, and (f) industrial
                design rights; in each case, including any registrations of,
                applications to register, and renewals and extensions of, any of
                the foregoing in any jurisdiction in the world.
              </li>
              <li>
                <b class="incline">&quot;Malicious Code&quot;</b> means viruses,
                worms, time bombs, Trojan horses and other harmful or malicious
                code, files, scripts, agents or programs.
              </li>
              <li>
                <b class="incline">&quot;Open Source Software&quot;</b> means
                all software that is available under the GNU Affero General
                Public License (AGPL), GNU General Public License (GPL), GNU
                Lesser General Public License (LGPL), Mozilla Public License
                (MPL), Apache License, BSD licenses, or any other license that is
                approved by the Open Source Initiative (www.opensource.org).
              </li>
              <li>  
              <b class="incline">&quot;Term&quot;</b> means a period during which a Customer has access to LINKPlanner. The Term will continue unless the Customer closes their account or Customer’s access to LINKPlanner is terminated by Airspan Networks.
              </li>
              <li>
                <b class="incline">&quot;Services&quot;</b> means the Service
                provided by Airspan Networks through its LINKPlanner network
                planning system and any Support Services offered through or in
                connection with the LINKPlanner network planning system.
              </li>
              <li>
                <b class="incline">&quot;Support Services&quot;</b> means the
                support and maintenance services offered by Airspan Networks and
                any upgraded or premium support and maintenance services, if
                made available by Airspan Networks, or if purchased by Customer
                separately.
              </li>
              <li>
                <b class="incline">&quot;Users&quot;</b> means Customer’s
                employees, consultants, contractors, agents and third parties
                with whom Customer may transact business who are authorized by
                Customer to access and use Customer’s account on LINKPlanner.
              </li>
            </ol>
          </li>
          <li>
            <b>LICENSES AND RESTRICTIONS.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Access and Use License</i>.</b> Subject to
                Customer’s compliance with the terms and conditions contained in
                these Terms, Airspan Networks hereby grants to Customer, during
                the relevant Term, a limited, non-exclusive, non-transferable
                right for its Users to access and use the Service on LINKPlanner
                in accordance with the Documentation in each case solely for
                Customer’s internal business purposes and not for the benefit of
                any other person or entity. Customer’s use of the Service and
                access to LINKPlanner may be subject to certain limitations,
                such as, for example, limits on storage capacity for Customer
                Data, which limitations will be provided to Customer as they
                become required.
              </li>
              <li>
                <b class="m-r-xs"><i>Restrictions</i>.</b> Customer shall not,
                directly or indirectly, nor shall Customer permit any User or
                third party to: (a) reverse engineer, decompile, disassemble or
                otherwise attempt to discover the object code, source code or
                underlying ideas or algorithms of LINKPlanner or the Services
                provided by Airspan Networks (b) modify, translate, or create
                derivative works based on any element of LINKPlanner or the
                Services provided by Airspan Networks or any related
                Documentation (c) rent, lease, distribute, sell, resell, assign,
                or otherwise transfer its rights to access or use LINKPlanner or
                any Service provided by Airspan Networks (d) use LINKPlanner for
                timesharing purposes or otherwise for the benefit of any person
                or entity other than for the benefit of Customer and Users (e)
                remove any proprietary notices from the Documentation (f)
                publish or disclose to third parties any evaluation of
                LINKPlanner without Airspan Networks’ prior written consent (g)
                use LINKPlanner or any Services provided by Airspan Networks for
                any purpose other than its intended purpose (h) interfere with
                or disrupt the integrity or performance of LINKPlanner (i)
                introduce any Open Source Software into LINKPlanner or any
                Service provided by Airspan Networks or (j) attempt to gain
                unauthorized access to LINKPlanner or any Service provided by
                Airspan Networks or their related systems or networks.
              </li>
              <li>
                <b class="m-r-xs"><i>Reservation of Rights</i>.</b> Except as
                expressly granted in these Terms, there are no other licenses
                granted to Customer, express, implied or by way of estoppel. All
                rights not granted in these Terms are reserved by Airspan
                Networks.
              </li>
            </ol>
          </li>
          <li>
            <b>PASSWORDS AND SECURITY.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Passwords</i>.</b> Customer shall choose
                user logins and passwords for each of their Users authorized to
                access and use LINKPlanner. Customer shall be, and shall ensure
                that each of their respective Users are, responsible for
                maintaining the confidentiality of all user logins and passwords
                and for ensuring that each user login and password is used only
                by the User to which it was issued. Customer is solely
                responsible for any and all access and use of LINKPlanner and
                the Services provided by Airspan Networks that occurs using
                logins and passwords that are issued in connection therewith to
                any of Customer’s Users. Customer shall restrict its Users from
                sharing passwords. Customer agrees to immediately notify Airspan
                Networks of any unauthorized use of any account or login and
                password issued to Customer’s Users, or any other breach of
                security known to Customer. Airspan Networks shall have no
                liability for any loss or damage arising from Customer’s failure
                to comply with the terms set forth in this Section.
              </li>
              <li>
                <b class="m-r-xs"><i>No Circumvention of Security</i>.</b>
                Neither Customer nor any User may circumvent or otherwise
                interfere with any user authentication or security of
                LINKPlanner. Customer will immediately notify Airspan Networks
                of any breach, or attempted breach, of security known to
                Customer.
              </li>
              <li>
                <b class="m-r-xs"><i>Security</i>.</b> Airspan Networks will use
                commercially reasonable efforts to maintain appropriate
                administrative, physical and technical safeguards for protection
                of the security, confidentiality and integrity of Customer Data.
                Notwithstanding the foregoing, Customer acknowledges that,
                notwithstanding any security precautions deployed by Airspan
                Networks, the use of, or connection to, the Internet provides
                the opportunity for unauthorized third parties to circumvent
                such precautions and illegally gain access to LINKPlanner and
                the data processed thereon including Customer Data. Airspan
                Networks cannot and does not guaranty the privacy, security,
                integrity or authenticity of any information transmitted over or
                stored in any system connected to or accessible via the Internet
                or otherwise or that any such security precautions will be
                adequate or sufficient. Airspan Networks shall not (a) modify
                Customer Data, (b) disclose Customer Data except as compelled by
                law or as expressly permitted in writing by Customer, or (c)
                access Customer Data except to provide the Services and prevent
                or address service or technical problems, or at Customer's
                request in connection with customer support matters. All data
                accessed or, processed or analyzed by or stored through
                LINKPlanner shall be subject to the Airspan Networks privacy
                policy located at airspan.com/about/legal-policy/.
              </li>
            </ol>
          </li>
          <li>
            <b>CUSTOMER OBLIGATIONS.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Customer System</i>.</b> Customer is
                responsible for (a) obtaining, deploying and maintaining the
                Customer System, and all computer hardware, software, modems,
                routers and other communications equipment necessary for
                Customer and their respective Users to access and use
                LINKPlanner and the Services offered by Airspan Networks in
                connection therewith, via the Internet; (b) contracting with
                third party ISP, telecommunications and other service providers
                to access and use LINKPlanner via the Internet; and (c) paying
                all third party fees and access charges incurred in connection
                with the foregoing. Except as specifically set forth in these
                Terms, Airspan Networks shall not be responsible for supplying
                any hardware, software or other equipment to Customer under
                these Terms.
              </li>
              <li>
                <b class="m-r-xs"><i>Acceptable Use Policy</i>.</b> Customer
                shall be solely responsible for its actions and the actions of
                its Users while using LINKPlanner and the Services offered by
                Airspan Networks. Customer acknowledges and agrees: (a) to abide
                by all local, state, national, and international laws and
                regulations applicable to Customer’s use of LINKPlanner and the
                Services, including without limitation the provision and storage
                of Customer Data; (b) not to send or store data on or to
                LINKPlanner which violates the rights of any individual or
                entity established in any jurisdiction; (c) not to upload in any
                way any information or content that contain Malicious Code or
                data that may damage the operation of LINKPlanner or any
                Services provided by Airspan Networks or another's computer or
                mobile device; (d) not to upload in any way any data regarding
                an individual’s financial or economic identity, sexual
                orientation, religious beliefs, medical or physical identity,
                including any information comprised of either “Protected Health
                Information” subject to and defined by the Health Insurance
                Portability and Accountability Act, or an individual’s first
                name and last name, or first initial and last name, in
                combination with any one or more of the following data elements
                that relate to such individual: Social Security number, driver's
                license number or state-issued identification card number,
                financial account number, or credit or debit card number, with
                or without any required security code, access code, personal
                identification number or password, that would permit access to
                an individual’s financial account; (e) not to use LINKPlanner or
                the Services provided by Airspan Networks for illegal,
                fraudulent, unethical or inappropriate purposes; (f) not to
                interfere or disrupt networks connected to LINKPlanner or
                interfere with other ability to access or use LINKPlanner; (g)
                not to distribute, promote or transmit through LINKPlanner any
                unlawful, harmful, obscene, pornographic or otherwise
                objectionable material of any kind or nature; (h) not to
                transmit or post any material that encourages conduct that could
                constitute a criminal offense or give rise to civil liability;
                (i) not to interfere with another customer’s use and enjoyment
                of LINKPlanner or the Services provided by Airspan Networks or
                another person or entity's use and enjoyment of similar
                services; (j) not to use LINKPlanner in any manner that impairs
                LINKPlanner, including without limitation the servers and
                networks on which LINKPlanner is provided; (k) to comply with
                all regulations, policies and procedures of networks connected
                to LINKPlanner and Airspan Networks’ service providers; and (l)
                to use LINKPlanner only in accordance with the Documentation.
                Customer acknowledges and agrees that Airspan Networks neither
                endorses the contents of any Customer communications, Customer
                Data, or Other Information (as defined in Section 10.2 below)
                nor assumes any responsibility for any offensive material
                contained therein, any infringement of third party Intellectual
                Property Rights arising therefrom or any crime facilitated
                thereby. Airspan Networks may remove any violating content
                posted or stored using LINKPlanner or the Services provided by
                Airspan Networks or transmitted through LINKPlanner, without
                notice to Customer. Notwithstanding the foregoing, Airspan
                Networks does not guarantee, and does not and is not obligated
                to verify, authenticate, monitor or edit the Customer Data,
                Other Information, or any other information or data input into
                or stored in or in connection with use of LINKPlanner for
                completeness, integrity, quality, accuracy or otherwise.
                Customer shall be responsible and liable for the completeness,
                integrity, quality and accuracy of Customer Data and Other
                Information input into LINKPlanner or provided by or on behalf
                of Customer in connection with use of the Services. Airspan
                Networks reserves the right to amend, alter, or modify
                Customer’s conduct requirements as set forth in these Terms at
                any time. Airspan Networks may deliver notice of such updated
                requirements to Customer via e-mail or through access to the
                Customer’s account on LINKPlanner. Customer’s continued access
                to and use of LINKPlanner following issuance of such updated
                Customer requirements shall constitute Customer’s acceptance
                thereof. Airspan Networks may upon written notice to Customer
                amend this Section 4.2.
              </li>
              <li>
                <b class="m-r-xs"
                  ><i
                    >Accuracy of Customer’s Contact Information; Email
                    Notices</i
                  >.</b
                >
                Customer agrees to provide accurate, current and complete
                information as necessary for Airspan Networks to communicate
                with Customer from time to time regarding the Services, issue
                invoices or accept payment, or contact Customer for other
                account-related purposes. Customer agrees to keep any online
                account information current and inform Airspan Networks of any
                changes in Customer’s legal business name, address, email
                address and phone number. Customer agrees to accept emails from
                Airspan Networks at the e-mail addresses specified by its Users
                for login purposes. In addition, Customer agrees that Airspan
                Networks may rely and act on all information and instructions
                provided to Airspan Networks by Users from the above-specified
                e-mail address.
              </li>
              <li>
                <b class="m-r-xs"><i>Temporary Suspension</i>.</b> Airspan
                Networks may temporarily suspend Customer’s or their respective
                Users’ access to LINKPlanner in the event that either Customer
                any of their Users is engaged in, or Airspan Networks in good
                faith suspects Customer or any of their Users is engaged in, any
                unauthorized conduct (including, but not limited to any
                violation of these Terms). Airspan Networks will attempt to
                contact Customer prior to or contemporaneously with such
                suspension; provided, however, that Airspan Networks’ exercise
                of the suspension rights herein shall not be conditioned upon
                Customer’s receipt of any notification. A suspension may take
                effect for Customer’s entire account and Customer understands
                that such suspension would therefore include User sub-accounts.
                Customer agrees that Airspan Networks shall not be liable to
                Customer, any of its Users, or any other third party if Airspan
                Networks exercises its suspension rights as permitted by this
                Section. Upon determining that Customer has ceased the
                unauthorized conduct leading to the temporary suspension to
                Airspan Networks’ reasonable satisfaction, Airspan Networks
                shall reinstate Customer’s and their respective Users’ access
                and use of LINKPlanner and the Services provided by Airspan
                Networks. Notwithstanding anything in this Section to the
                contrary, Airspan Networks’ suspension of access to LINKPlanner
                is in addition to any other remedies that Airspan Networks may
                have under these Terms or otherwise, including but not limited
                to termination of these Terms for cause. Additionally, if there
                are repeated incidences of suspension, regardless of the same or
                different cause and even if the cause or conduct is ultimately
                cured or corrected, Airspan Networks may, in its reasonable
                discretion, determine that such circumstances, taken together,
                constitute a material breach.
              </li>
              <li>
                <b class="m-r-xs"><i>Data Privacy</i>.</b> Customer understands
                and expressly agrees that Customer Data may be transferred to
                and processed by Airspan Networks (including by Airspan
                Networks’ affiliates and service providers) in the United
                States, the United Kingdom, India, Germany, Japan and any other
                jurisdiction in which Airspan Networks or its vendors or service
                providers are located. Customer further acknowledges that
                Customer Data may include MAC address, IP address, location
                information and other information that is considered personal
                information by or otherwise regulated under applicable data
                privacy, protection, security or similar laws, rules and
                regulations <b class="m-n">(&quot;Privacy Laws&quot;)</b>.
                Customer acknowledges and agrees that it is responsible for
                ensuring that any collection, use, storage, access, transfer and
                other processing (collectively, “Processing”) of Customer Data
                pursuant to this Agreement and the Services (including any
                personal information or other regulated categories of
                information), as well as the transfer of Customer Data, pursuant
                to the Agreement complies with all applicable laws, rules and
                regulations. Without limiting the foregoing, Customer
                represents, warrants and covenants that, where required by
                applicable law, it shall provide notice to and obtain consent
                from end users (individuals or otherwise) regarding the
                Processing of Customer Data by Customer and Airspan Networks
                pursuant to this Agreement and the Services.
              </li>
            </ol>
          </li>
          <li>
            <b>AVAILABILITY AND SUPPORT SERVICES.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Availability</i>.</b> Subject to the terms and conditions of these Terms, Airspan Networks will use commercially reasonable efforts to make LINKPlanner available with minimal downtime 24 hours a day, 7 days a week; provided, however, that the following are excepted from availability commitments: (a) planned downtime and routine maintenance times currently scheduled from 01:00 a.m. to 06:00 a.m. Central Time and as otherwise specified by Airspan Networks, or (b) any unavailability caused by circumstances beyond Airspan Networks’ reasonable control, including without limitation, acts of God, acts of government, flood, fire, earthquakes, civil unrest, acts of terror, strikes or other labor problems or Internet service provider failures or delays. Certain enhancements to LINKPlanner and the Services provided by Airspan Networks in connection therewith made generally available at no cost to all subscribing customers during the applicable Term will be made available to Customer at no additional charge. However, the availability of some new enhancements to LINKPlanner or the Services provided in connection therewith may require the payment of additional fees, and Airspan Networks will determine at its sole discretion whether access to any other such new enhancements will require an additional fee. These Terms will apply to, and LINKPlanner includes, any enhancements, updates, upgrades and new modules to the LINKPlanner and the Services provided in connection therewith, subsequently provided by Airspan Networks to Customer hereunder.
              </li>
              <li>
                <b class="m-r-xs"><i>Support</i>.</b> Airspan Networks makes a
                variety of Support Services offerings available to its customers
                for the Service, Airspan Networks will
                provide Customer with the level of support to which Customer is
                entitled based on Customer’s purchase as specified in a separate
                order for such Support Services.
              </li>
            </ol>
          </li>
          <li>
            <b class="m-r-xs">FEES AND PAYMENT.</b> Airspan Networks currently
            makes the Services available on LINKPlanner to its customers at no
            charge. However, Airspan Networks reserves the right to impose fees
            for the Services in the future or in connection with the use of
            specified features of or Services offered on, LINKPlanner. In such
            case, Airspan Networks will provide advance notice of any fees to
            Customer.
          </li>
          <li>
            <b>REPRESENTATIONS, WARRANTIES AND DISCLAIMER.</b>
            <ol>
              <li>
                <b class="m-r-xs"
                  ><i>Mutual Representations and Warranties</i>.</b
                >
                Each party represents, warrants and covenants that: (a) it has
                the full power and authority to enter into these Terms and to
                perform its obligations hereunder, without the need for any
                consents, approvals or immunities not yet obtained; and (b) its
                acceptance of and performance under these Terms shall not breach
                any oral or written agreement with any third party or any
                obligation owed by it to any third party to keep any information
                or materials in confidence or in trust.
              </li>
              <li>
                <b class="m-r-xs"><i>Evaluations of New Services</i>.</b> From
                time to time Airspan Networks may invite Customer to try, at no
                charge, Airspan Networks products or services that are not
                generally available to Airspan Networks customers
                <b class="m-n">(&quot;Non-GA Services&quot;)</b>. Customer may
                accept or decline any such trial in its sole discretion. Any
                Non-GA Services will be clearly designated as beta, pilot,
                limited release, developer preview, non-production or by a
                description of similar import. Non-GA Services are provided for
                evaluation purposes and not for production use, are not
                supported, may contain bugs or errors (but shall not contain any
                Malicious Code), and may be subject to additional terms that
                shall be provided by Airspan Networks to Customer prior to or
                concurrent with Airspan Networks’ invitation to the applicable
                Non-GA Services. Non-GA Services are not considered “Services”
                hereunder. Customer has the right to discontinue Non-GA Services
                at any time in its sole discretion and may never make them
                generally available.
              </li>
              <li class="cap">
                <b class="m-r-xs"><i>Disclaimer</i>.</b> EXCEPT FOR THE
                WARRANTIES SET FORTH IN THIS SECTION 7, LINKPLANNER, THE
                SERVICES AND ANY NON-GA SERVICES ARE PROVIDED ON AN AS-IS BASIS.
                CUSTOMER’S USE OF LINKPLANNER, THE SERVICES AND NON-GA SERVICES
                IS AT ITS OWN RISK. AIRSPAN NETWORKS DOES NOT MAKE, AND HEREBY
                DISCLAIMS, ANY AND ALL OTHER EXPRESS, STATUTORY AND IMPLIED
                WARRANTIES, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                NONINFRINGEMENT AND TITLE, QUALITY, SUITABILITY, OPERABILITY,
                CONDITION, SYSTEM INTEGRATION, NON-INTERFERENCE, WORKMANSHIP,
                TRUTH, ACCURACY (OF DATA OR ANY OTHER INFORMATION OR CONTENT),
                ABSENCE OF DEFECTS, WHETHER LATENT OR PATENT, AND ANY WARRANTIES
                ARISING FROM A COURSE OF DEALING, USAGE, OR TRADE PRACTICE. ANY
                WARRANTIES MADE BY AIRSPAN NETWORKS ARE FOR THE BENEFIT OF THE
                USER OF THE WEBSITE ONLY AND NOT FOR THE BENEFIT OF ANY THIRD
                PARTY. ANY MATERIALS PROVIDED THROUGH LINKPLANNER OR THE
                SERVICES ARE LICENSED AND NOT SOLD.
                <p>
                  NO AGENT OF AIRSPAN NETWORKS IS AUTHORIZED TO ALTER OR EXPAND
                  THE WARRANTIES OF AIRSPAN NETWORKS AS SET FORTH HEREIN.
                  AIRSPAN NETWORKS DOES NOT WARRANT THAT: (A) THE USE OF
                  LINKPLANNER OR ANY SERVICES OR NON-GA SERVICES WILL BE SECURE,
                  TIMELY, UNINTERRUPTED OR ERROR-FREE OR OPERATE IN COMBINATION
                  WITH ANY OTHER HARDWARE, SOFTWARE, SYSTEM OR DATA (B)
                  LINKPLANNER OR THE SERVICES WILL MEET CUSTOMER’S REQUIREMENTS
                  OR EXPECTATIONS; (C) ANY STORED DATA WILL BE ACCURATE OR
                  RELIABLE; (D) THE QUALITY OF ANY INFORMATION OR OTHER MATERIAL
                  OBTAINED BY CUSTOMER THROUGH LINKPLANNER OR THE SERVICES OR
                  NON-GA SERVICES WILL MEET CUSTOMER’S REQUIREMENTS OR
                  EXPECTATIONS (E) LINKPLANNER, THE SERVICES AND NON-GA SERVICES
                  WILL BE ERROR-FREE OR THAT ERRORS OR DEFECTS IN LINKPLANNER,
                  THE SERVICES AND NON-GA SERVICES WILL BE CORRECTED OR (F)
                  LINKPLANNER, THE SERVER(S) UPON WHICH LINKPLANNER RUNS OR THAT
                  MAKE THE SERVICES AND NON-GA SERVICES AVAILABLE ARE FREE OF
                  VIRUSES OR OTHER HARMFUL COMPONENTS. LINKPLANNER, THE SERVICES
                  AND NON-GA SERVICES MAY BE SUBJECT TO LIMITATIONS, DELAYS AND
                  OTHER PROBLEMS INHERENT IN THE USE OF THE INTERNET AND
                  ELECTRONIC COMMUNICATIONS. AIRSPAN NETWORKS IS NOT RESPONSIBLE
                  FOR ANY DELAYS, DELIVERY FAILURES, OR OTHER DAMAGES RESULTING
                  FROM SUCH PROBLEMS.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <b>INDEMNIFICATION.</b>
            <ol>
              <li>
                <b><i>Airspan Networks Indemnity</i>.</b>
                <ol>
                  <li>
                    <u class="m-r-xs">General.</u> Airspan Networks, at its
                    expense, shall defend Customer and their respective
                    officers, directors and employees (the
                    <b class="m-n">&quot;Customer Indemnified Parties&quot;</b>)
                    from and against all actions, proceedings, claims and
                    demands by a third party (a
                    <b class="m-n">&quot;Third-Party Claim&quot;</b>) alleging
                    that LINKPlanner or the Services provided by Airspan
                    Networks infringe any copyright or patent or misappropriates
                    any trade secret and shall pay all damages, costs and
                    expenses, including attorneys’ fees and costs (whether by
                    settlement of or award by a final judicial judgment)
                    incurred by the Customer Indemnified Parties from any such
                    Third-Party Claim. Airspan Networks’ obligations under this
                    Section are conditioned upon (i) Airspan Networks being
                    promptly notified in writing of any claim under this
                    Section, (ii) Airspan Networks having the sole and exclusive
                    right to control the defense and settlement of the claim,
                    and (iii) Customer providing all reasonable assistance (at
                    Airspan Networks’ expense and reasonable request) in the
                    defense of such claim. In no event shall Customer settle any
                    claim without Airspan Networks’ prior written approval.
                    Customer may, at its own expense, engage separate counsel to
                    advise Customer regarding a Claim and to participate in the
                    defense of the claim, subject to Airspan Networks’ right to
                    control the defense and settlement.
                  </li>
                  <li>
                    <u class="m-r-xs">Mitigation.</u> If any claim which Airspan
                    Networks is obligated to defend has occurred, or in Airspan
                    Networks’ determination is likely to occur, Airspan Networks
                    may, in its sole discretion and at its option and expense
                    (a) obtain for Customer the right to use the Airspan
                    Networks Services, (b) substitute a functionality
                    equivalent, non-infringing replacement for such the Airspan
                    Networks Services, (c) modify Airspan Networks Services to
                    make it non-infringing and functionally equivalent, or (d)
                    terminate these Terms and refund to Customer any prepaid
                    amounts attributable the period of time between the date
                    Customer was unable to use the Airspan Networks Services due
                    to such claim and the remaining days in the then-current
                    Term.
                  </li>
                  <li>
                    <u class="m-r-xs">Exclusions.</u> Notwithstanding anything
                    to the contrary in these Terms, the foregoing obligations
                    shall not apply with respect to a claim of infringement if
                    such claim arises out of (i) Customer’s use of infringing
                    Customer Data (ii) use of LINKPlanner or any Service
                    provided by Airspan Networks in combination with any
                    software, hardware, network or system not supplied by
                    Airspan Networks where the alleged infringement relates to
                    such combination, (iii) any modification or alteration of
                    LINKPlanner other than by Airspan Networks, (iv) Customer’s
                    continued use of LINKPlanner or any Service provided by
                    Airspan Networks after Airspan Networks notifies Customer to
                    discontinue use because of an infringement claim, (v) use of
                    Open Source Software (vi) Customer’s violation of applicable
                    law (vii) Third Party Offerings or (viii) Customer System.
                  </li>
                  <li>
                    <u class="m-r-xs">Sole Remedy.</u
                    ><span class="cap"
                      >THE FOREGOING STATES THE ENTIRE LIABILITY OF AIRSPAN
                      NETWORKS WITH RESPECT TO THE INFRINGEMENT OF ANY
                      INTELLECTUAL PROPERTY OR PROPRIETARY RIGHTS BY LINKPLANNER
                      OR ANY SERVICE OFFERED BY AIRSPAN NETWORKS OR OTHERWISE,
                      AND CUSTOMER HEREBY EXPRESSLY WAIVES ANY OTHER LIABILITIES
                      OR OBLIGATIONS OF AIRSPAN NETWORKS WITH RESPECT
                      THERETO.</span
                    >
                  </li>
                </ol>
              </li>
              <li>
                <b><i>Customer Indemnity</i>.</b> Customer shall defend Airspan
                Networks and its licensors and their respective officers,
                directors and employees
                <b class="m-n"
                  >(&quot;Airspan Networks Indemnified Parties&quot;)</b
                >
                from and against any and all Third-Party Claims which arise out
                of or relate to: (a) a claim or threat that the Customer Data or
                Customer System (and the exercise by Airspan Networks of the
                rights granted herein with respect thereto) infringes,
                misappropriates or violates any third party’s Intellectual
                Property Rights; (b) Customer’s use or alleged use of
                LINKPlanner other than as permitted under these Terms; (c)
                arising from the occurrence of any of the exclusions set forth
                in Section 8.1(c) (Exclusions); or (d) arising out of or
                relating to any violation of Section 4.5, or any violation of
                applicable Privacy Laws. Customer shall pay all damages, costs
                and expenses, including attorneys’ fees and costs (whether by
                settlement or award of by a final judicial judgment) incurred by
                the Airspan Networks Indemnified Parties from any such
                Third-Party Claim. Customer’s obligations under this Section are
                conditioned upon (x) Customer being promptly notified in writing
                of any claim under this Section, (y) Customer having the sole
                and exclusive right to control the defense and settlement of the
                claim, and (z) Airspan Networks providing all reasonable
                assistance (at Customer’s expense and reasonable request) in the
                defense of such claim. In no event shall Airspan Networks settle
                any claim without Customer’s prior written approval. Airspan
                Networks may, at its own expense, engage separate counsel to
                advise Airspan Networks regarding a Third-Party Claim and to
                participate in the defense of the claim, subject to Customer’s
                right to control the defense and settlement.
              </li>
            </ol>
          </li>
          <li>
            <b>CONFIDENTIALITY</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Confidential Information</i>.</b>
                “Confidential Information” means any and all non-public
                technical and non-technical information disclosed by one party
                (the “Disclosing Party”) to the other party (the “Receiving
                Party”) in any form or medium, whether oral, written, graphical
                or electronic, pursuant to these Terms, that is marked
                confidential and proprietary, or that the Disclosing Party
                identifies as confidential and proprietary, or that by the
                nature of the circumstances surrounding the disclosure or
                receipt ought to be treated as confidential and proprietary
                information, including but not limited to: (a) techniques,
                sketches, drawings, models, inventions (whether or not patented
                or patentable), know-how, processes, apparatus, formulae,
                equipment, algorithms, software programs, software source
                documents, APIs, and other creative works (whether or not
                copyrighted or copyrightable); (b) information concerning
                research, experimental work, development, design details and
                specifications, engineering, financial information, procurement
                requirements, purchasing, manufacturing, customer lists,
                business forecasts, sales and merchandising and marketing plans
                and information and (c) proprietary or confidential information
                of any third party who may disclose such information to
                Disclosing Party or Receiving Party in the course of Disclosing
                Party’s business. Confidential Information also includes all
                summaries and abstracts of Confidential Information.
              </li>
              <li>
                <b class="m-r-xs"><i>Non-Disclosure</i>.</b> Each party
                acknowledges that in the course of the performance of these
                Terms, it may obtain the Confidential Information of the other
                party. The Receiving Party shall, at all times, both during the
                Term and thereafter, keep in confidence and trust all of the
                Disclosing Party’s Confidential Information received by it. The
                Receiving Party shall not use the Confidential Information of
                the Disclosing Party other than as necessary to fulfill the
                Receiving Party’s obligations or to exercise the Receiving
                Party’s rights under these Terms. Each party agrees to secure
                and protect the other party’s Confidential Information with the
                same degree of care and in a manner consistent with the
                maintenance of such party’s own Confidential Information (but in
                no event less than reasonable care), and to take appropriate
                action by instruction or agreement with its employees or other
                agents who are permitted access to the other party’s
                Confidential Information to satisfy its obligations under this
                Section. The Receiving Party shall not disclose Confidential
                Information of the Disclosing Party to any person or entity
                other than its officers, employees and agents who need access to
                such Confidential Information in order to effect the intent of
                these Terms and who are subject to confidentiality obligations
                at least as stringent as the obligations set forth in these
                Terms.
              </li>
              <li>
                <b class="m-r-xs"
                  ><i>Exceptions to Confidential Information</i>.</b
                >
                The obligations set forth in Section 9.2 (Non-Disclosure) shall
                not apply to the extent that Confidential Information includes
                information which: (a) was known by the Receiving Party prior to
                receipt from the Disclosing Party either itself or through
                receipt directly or indirectly from a source other than one
                having an obligation of confidentiality to the Disclosing Party;
                (b) was developed by the Receiving Party without use of the
                Disclosing Party’s Confidential Information; or (c) becomes
                publicly known or otherwise ceases to be secret or confidential,
                except as a result of a breach of these Terms or any obligation
                of confidentiality by the Receiving Party. Nothing in these
                Terms shall prevent the Receiving Party from disclosing
                Confidential Information to the extent the Receiving Party is
                legally compelled to do so by any governmental investigative or
                judicial agency pursuant to proceedings over which such agency
                has jurisdiction; provided, however, that prior to any such
                disclosure, the Receiving Party shall (x) assert the
                confidential nature of the Confidential Information to the
                agency; (y) immediately notify the Disclosing Party in writing
                of the agency’s order or request to disclose; and (z) cooperate
                fully with the Disclosing Party in protecting against any such
                disclosure and in obtaining a protective order narrowing the
                scope of the compelled disclosure and protecting its
                confidentiality.
              </li>
              <li>
                <b class="m-r-xs"><i>Injunctive Relief</i>.</b> The Parties
                agree that any unauthorized disclosure of Confidential
                Information may cause immediate and irreparable injury to the
                Disclosing Party and that, in the event of such breach, the
                Receiving Party will be entitled, in addition to any other
                available remedies, to seek immediate injunctive and other
                equitable relief, without bond and without the necessity of
                showing actual monetary damages.
              </li>
            </ol>
          </li>
          <li>
            <b>PROPRIETARY RIGHTS.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Airspan Networks Services</i>.</b> As
                between Airspan Networks and Customer, all right, title and
                interest in LINKPlanner and the Services offered by Airspan
                Networks in connection therewith and any other Airspan Networks
                materials furnished or made available hereunder, and all
                modifications and enhancements thereof, and all suggestions,
                ideas and feedback proposed by Customer regarding LINKPlanner,
                including all copyright rights, patent rights and other
                Intellectual Property Rights in each of the foregoing, belong to
                and are retained solely by Airspan Networks or Airspan Networks’
                licensors and providers, as applicable. Customer hereby does and
                will irrevocably assign to Airspan Networks all evaluations,
                ideas, feedback and suggestions made by Customer to Airspan
                Networks regarding the Airspan Networks Service (collectively,
                “Feedback”) and all Intellectual Property Rights in the
                Feedback.
              </li>
              <li>
                <b class="m-r-xs"><i>Customer Data</i>.</b> As between Airspan
                Networks and Customer, all right, title and interest in (a) the
                Customer Data, (b) other information input into LINKPlanner by
                Customer (collectively, “Other Information”) and (c) all
                Intellectual Property Rights in each of the foregoing, belong to
                and are retained solely by Customer. Customer hereby grants to
                Airspan Networks a limited, non-exclusive, royalty-free,
                worldwide license to use the Customer Data and perform all acts
                with respect to the Customer Data as may be necessary for
                Airspan Networks to provide the Services to Customer, and a
                non-exclusive, perpetual, irrevocable, worldwide, royalty-free,
                fully paid license to use, reproduce, modify and distribute the
                Other Information as a part of the Aggregated Statistics (as
                defined in Section 10.3 below). To the extent that receipt of
                the Customer Data requires Airspan Networks to utilize any
                account information from a third party service provider,
                Customer shall be responsible for obtaining and providing
                relevant account information and passwords, and Airspan Networks
                hereby agrees to access and use the Customer Data solely for
                Customer’s benefit and as set forth in these Terms. As between
                Airspan Networks and Customer, Customer is solely responsible
                for the accuracy, quality, integrity, legality, reliability, and
                appropriateness of all Customer Data and the rights to use and
                access such Customer Data.
              </li>
              <li>
                <b class="m-r-xs"><i>Aggregated Statistics</i>.</b>
                Notwithstanding anything else in these Terms or otherwise,
                Airspan Networks may monitor Customer’s use of the Services and
                use data and information related to such use, Customer Data, and
                Other Information in an aggregate and anonymous manner,
                including to compile statistical and performance information
                related to the provision and operation of the Airspan Networks
                Services (“Aggregated Statistics”). As between Airspan Networks
                and Customer, all right, title and interest in the Aggregated
                Statistics and all Intellectual Property Rights therein, belong
                to and are retained solely by Airspan Networks. Customer
                acknowledges that Airspan Networks will be compiling Aggregated
                Statistics based on Customer Data, Other Information, and
                information input by other customers into the Airspan Networks
                Service and Customer agrees that Airspan Networks may (a) make
                such Aggregated Statistics publicly available, and (b) use such
                information to the extent and in the manner required by
                applicable law or regulation and for purposes of data gathering,
                analysis, service enhancement and marketing, provided that such
                data and information does not identify Customer or its
                Confidential Information.
              </li>
            </ol>
          </li>
          <li>
            <b>LIMITATION OF LIABILITY.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>No Consequential Damages</i>.</b> NEITHER
                AIRSPAN NETWORKS NOR ITS LICENSORS OR CUSTOMER SHALL BE LIABLE
                FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE
                DAMAGES, OR ANY DAMAGES FOR LOST DATA, BUSINESS INTERRUPTION,
                LOST PROFITS, LOST REVENUE OR LOST BUSINESS, ARISING OUT OF OR
                IN CONNECTION WITH THESE TERMS, EVEN IF AIRSPAN NETWORKS OR ITS
                LICENSORS OR CUSTOMER HAVE BEEN ADVISED OF THE POSSIBILITY OF
                SUCH DAMAGES, INCLUDING WITHOUT LIMITATION, ANY SUCH DAMAGES
                ARISING OUT OF THE LICENSING, PROVISION OR USE OF LINKPLANNER OR
                THE SERVICES, ANCILLARY SERVICES, SUPPORT SERVICES OR THE
                RESULTS THEREOF. AIRSPAN NETWORKS WILL NOT BE LIABLE FOR THE
                COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES.
              </li>
              <li>
                <b class="m-r-xs"><i>Limits on Liability</i>.</b> NEITHER
                AIRSPAN NETWORKS NOR ITS LICENSORS OR CUSTOMER SHALL BE LIABLE
                FOR CUMULATIVE, AGGREGATE DAMAGES GREATER THAN AN AMOUNT EQUAL
                TO THE LESSER OF (a) THE AMOUNTS PAID BY CUSTOMER TO AIRSPAN
                NETWORKS UNDER THESE TERMS DURING THE PERIOD OF SIX (6) MONTHS
                PRECEDING THE DATE ON WHICH THE CLAIM FIRST ACCRUED, AND (b) THE
                AMOUNT OF FEES PAID BY CUSTOMER IN A SINGLE SUBSCRIPTION TERM
                WITHOUT REGARD TO WHETHER SUCH CLAIM IS BASED IN CONTRACT, TORT
                (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE.
              </li>
              <li>
                <b class="m-r-xs"><i>Essential Purpose</i>.</b> CUSTOMER
                ACKNOWLEDGES THAT THE TERMS IN THIS SECTION 11 (LIMITATION OF
                LIABILITY) SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY
                APPLICABLE LAW AND SHALL APPLY EVEN IF AN EXCLUSIVE OR LIMITED
                REMEDY STATED HEREIN FAILS OF ITS ESSENTIAL PURPOSE.
              </li>
            </ol>
          </li>
          <li>
            <b>TERM AND TERMINATION.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Term</i>.</b> These Terms commence on the
                Activation Date of the LINKPlanner account and continue until
                the termination of the account.
              </li>
              <li>
                <b class="m-r-xs"><i>Termination for Cause</i>.</b> A party may
                terminate these Terms, upon written notice to the other party in
                the event the other party (a) files a petition for bankruptcy or
                has a petition for bankruptcy filed against it that is not
                dismissed within sixty (60) calendar days after filing or admits
                its inability to pay its debts as they mature, makes an
                assignment for the benefit of its creditors or ceases to
                function as a going concern or to conduct its operations in the
                normal course of business and such termination shall occur
                immediately upon notice; or (b) commits a material breach of any
                provision of these Terms and does not remedy such breach within
                thirty (30) calendar days after receipt of notice from the
                non-defaulting party or such other period as the parties may
                agree.
              </li>
              <li>
                <b class="m-r-xs"><i>Termination for Convenience</i>.</b> Either
                party may terminate any Term for convenience on at least thirty
                (30) calendar days prior written notice to the other party.
              </li>
              <li>
                <b class="m-r-xs"><i>Effects of Termination</i>.</b> Upon
                expiration or termination of these Terms, Customer’s use of and
                access to LINKPlanner and any Services provided by Airspan
                Networks and the performance of all Support Services shall
                cease. Airspan Networks shall have no obligation to maintain or
                provide any Customer Data and may thereafter, unless legally
                prohibited, delete all Customer Data in its systems or otherwise
                in its possession or under its control.
              </li>
              <li>
                <b class="m-r-xs"><i>Survival</i>.</b> This Section and Sections
                1, 2.3 (Restrictions), 2.4 (Reservation of Rights), 7.3
                (Disclaimer), 9 (Confidentiality), 10 (Proprietary Rights), 11
                (Limitation of Liability), 12.4 (Effects of Termination) and 13
                (Miscellaneous) shall survive any termination or expiration of
                these Terms.
              </li>
            </ol>
          </li>
          <li>
            <b>MISCELLANEOUS.</b>
            <ol>
              <li>
                <b class="m-r-xs"><i>Notices</i>.</b> Airspan Networks may give
                notice to Customer by means of a general notice through the
                Airspan Networks Service interface, electronic mail to
                Customer’s e-mail address on record with Airspan Networks, or by
                written communication sent by first class postage prepaid mail
                or nationally recognized overnight delivery service to
                Customer’s address on record with Airspan Networks. Customer may
                give notice to Airspan Networks by written communication sent by
                first class postage prepaid mail or nationally recognized
                overnight delivery service addressed to Airspan Networks, 6652
                Pinecrest Dr, Suite 200, Plano, TX 75024 USA, Attention:
                Customer Support. Notice shall be deemed to have been given upon
                receipt or, if earlier, two (2) business days after mailing, as
                applicable. All communications and notices to be made or given
                pursuant to these Terms shall be in the English language.
              </li>
              <li>
                <b class="m-r-xs"><i>Governing Law</i>.</b> These Terms and the
                rights and obligations of the parties to and under this
                agreement shall be governed by and construed under the laws of
                the United States and the State of Illinois as applied to
                agreements entered into and to be performed in such State
                without giving effect to conflicts of laws rules or principles.
                The parties agree that the United Nations Convention on
                Contracts for the International Sale of Goods is specifically
                excluded from application to these Terms. Any dispute arising
                out of or in connection with these Terms, including but not
                limited to any question regarding its existence, interpretation,
                validity, performance, or termination, or any dispute between
                the parties arising from the parties' relationship created by
                these Terms, shall be referred to and finally resolved by
                arbitration administered by the American Arbitration Association
                under its rules. The number of arbitrators shall be one (1). The
                parties shall endeavor to agree upon the sole arbitrator and
                jointly nominate the arbitrator. If the parties cannot agree
                upon the sole arbitrator within a time prescribed by AAA, the
                parties shall request the AAA to propose five (5) arbitrators
                and each party shall rank the proposed arbitrators. The AAA
                shall appoint an arbitrator from the list of five (5), based
                upon the parties' rankings.
              </li>
              <li>
                <b class="m-r-xs"><i>U.S. Government Customers</i>.</b> If
                Customer is a Federal Government entity, Airspan Networks
                provides LINKPlanner and any Services thereunder, including
                related software and technology, for ultimate Federal Government
                end use solely in accordance with the following: Government
                technical data rights include only those rights customarily
                provided to the public with a commercial item or process and
                Government software rights related to the Airspan Networks
                Service include only those rights customarily provided to the
                public, as defined in these Terms. The technical data rights and
                customary commercial software license is provided in accordance
                with FAR 12.211 (Technical Data) and FAR 12.212 (Software) and,
                for Department of Defense transactions, DFAR 252.227-7015
                (Technical Data – Commercial Items) and DFAR 227.7202-3 (Rights
                in Commercial Computer Software or Computer Software
                Documentation). If greater rights are needed, a mutually
                acceptable written addendum specifically conveying such rights
                must be included in these Terms.
              </li>
              <li>
                <b class="m-r-xs"><i>Export</i>.</b> LINKPlanner utilizes
                software and technology that may be subject to United States and
                foreign export controls. Customer acknowledges and agrees that
                the Services shall not be used, and none of the underlying
                information, software, or technology may be transferred or
                otherwise exported or re-exported to countries as to which the
                United States maintains an embargo (collectively, “Embargoed
                Countries”), or to or by a national or resident thereof, or any
                person or entity on the U.S. Department of Treasury’s List of
                Specially Designated Nationals or the U.S. Department of
                Commerce’s Table of Denial Orders (collectively, “Designated
                Nationals”). The lists of Embargoed Countries and Designated
                Nationals are subject to change without notice. By using
                LINKPlanner and any Services offered by Airspan Networks,
                Customer represents and warrants that it is not located in,
                under the control of, or a national or resident of an Embargoed
                Country or Designated National. LINKPlanner may use encryption
                technology that is subject to licensing requirements under the
                U.S. Export Administration Regulations, 15 C.F.R. Parts 730-774
                and Council Regulation (EC) No. 1334/2000. Customer agrees to
                comply strictly with all applicable export laws and assume sole
                responsibility for obtaining licenses to export or re-export as
                may be required. Airspan Networks and its licensors make no
                representation that LINKPlanner is appropriate or available for
                use in other locations. Any diversion of the Customer Data
                contrary to law is prohibited. None of the Customer Data, nor
                any information acquired through the use of LINKPlanner or any
                Airspan Networks Service, is or will be used for nuclear
                activities, chemical or biological weapons, or missile projects.
              </li>
              <li>
                <b class="m-r-xs"><i>General</i>.</b> Customer shall not assign
                its rights hereunder, or delegate the performance of any of its
                duties or obligations hereunder, whether by merger, acquisition,
                sale of assets, operation of law, or otherwise, without the
                prior written consent of Airspan Networks. Any purported
                assignment in violation of the preceding sentence is null and
                void. Subject to the foregoing, this Agreement shall be binding
                upon, and inure to the benefit of, the successors and assigns of
                the parties thereto. Except as otherwise specified in these
                Terms, these Terms may be amended or supplemented only by a
                writing that refers explicitly to these Terms and that is signed
                on behalf of both parties. No waiver will be implied from
                conduct or failure to enforce rights. No waiver will be
                effective unless in a writing signed on behalf of the party
                against whom the waiver is asserted. If any of these Terms is
                found invalid or unenforceable that term will be enforced to the
                maximum extent permitted by law and the remainder of the Terms
                will remain in full force. The parties are independent
                contractors and nothing contained herein shall be construed as
                creating an agency, partnership, or other form of joint
                enterprise between the parties. These Terms constitute the
                entire agreement between the parties relating to this subject
                matter and supersedes all prior or simultaneous understandings,
                representations, discussions, negotiations, and agreements,
                whether written or oral. Except for your payment obligations
                hereunder, neither party shall be liable to the other party or
                any third party for failure or delay in performing its
                obligations under these Terms when such failure or delay is due
                to any cause beyond the control of the party concerned,
                including, without limitation, force majeure, governmental
                orders or restrictions, fire, or flood, provided that upon
                cessation of such events such party shall thereupon promptly
                perform or complete the performance of its obligations
                hereunder.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  </body>
</html>
`;

function TermsAndConditions({ intl }) {
  const { formatMessage } = intl;
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const optInInit = useSelector(
    (state: RootStateOrAny) => state.mainFrame.optIn
  );
  const [optOut, setOptOut] = useState(!optInInit);
  const displayTerms = location.pathname === '/terms';

  useEffect(() => {
    setOptOut(!optInInit);
  }, [optInInit]);

  const agreeTnC = () => {
    setLoading(true);
    postWithAuth('terms/accept', {
      terms_version: TERMS_VERSION,
      opt_in: !optOut, // while uncheck-->true, check--> false need backend
    })
      .then(() => {
        store.dispatch(
          updateTermsNConditions({
            optIn: !optOut,
            termsVersion: TERMS_VERSION,
          })
        );
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setError('Failed to update the terms and conditions');
      });
  };

  return (
    <MainFrame className="App">
      <Modal
        closeOnEscape={displayTerms ? true : false}
        closeIcon={displayTerms ? true : false}
        size="fullscreen"
        className="fullscreen modal"
        open={open}
        onClose={() => {
          setOpen(false);
          navigate(-1);
        }}
        closeOnDimmerClick={false}
      >
        <Modal.Header> {formatMessage(messages.linkplannerTerms)}</Modal.Header>
        <Modal.Content style={{ overflow: 'auto', maxHeight: '83vh' }}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </Modal.Content>
        {!displayTerms && (
          <Modal.Actions>
            <Checkbox
              style={{ float: 'left', marginTop: '4px' }}
              label={formatMessage(messages.promotionalMails)}
              name="optOut"
              checked={optOut}
              onChange={(e, { checked }) => setOptOut(checked)}
            />
            <Button positive loading={loading} onClick={agreeTnC}>
              {formatMessage(messages.agree)}
            </Button>
          </Modal.Actions>
        )}
        {error !== null && (
          <Message negative attached>
            <Message.Header>{formatMessage(messages.tncError)}</Message.Header>
            <p>{error}</p>
          </Message>
        )}
      </Modal>
    </MainFrame>
  );
}

export default injectIntl(TermsAndConditions);
